module.exports = __webpack_public_path__ + "media/images/area/feature/tohoku/related/vi/3-9a76c56bf034bdc5a260e3d3b109cedb.jpg";